import React, { useState, useMemo } from 'react';
import {
  Modal,
  Typography,
  List,
  ListItemText
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsRemoteOutlinedIcon from '@mui/icons-material/SettingsRemoteOutlined';
import { useHistory } from 'react-router-dom';
import {
  ModalBox,
  CloseIconButton,
  Header,
  HeaderTitle,
  SearchField,
  DeviceListItem,
  DeviceIcon,
  ListHeader
} from './styles';

const DevicesModal = ({ project, devices, isOpen, handleIsOpen }) => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredDevices = useMemo(() => {
    if (!searchTerm) return devices;
    return devices.filter(device =>
      device.uid.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [searchTerm, devices]);

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  const handleDeviceClick = deviceId => {
    history.push(`/device/${deviceId}`);
    handleIsOpen(false);
  };

  return (
    <Modal open={isOpen} onClose={() => handleIsOpen(false)} aria-labelledby="Devices modal">
      <ModalBox>
        <CloseIconButton onClick={() => handleIsOpen(false)}>
          <CloseIcon />
        </CloseIconButton>
        <Header>
          <HeaderTitle>
            <Typography variant="h4" fontWeight={500}>
              Devices
            </Typography>
            <Typography
              component="h6"
              color="textSecondary"
              fontWeight={500}
              m={0}
            >
              {project?.title}
            </Typography>
          </HeaderTitle>
          <SearchField
            variant="outlined"
            placeholder="Search devices"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </Header>
        <ListHeader>
          <Typography
            color="textSecondary"
            fontWeight={500}
            m={0}
          >
            Device
          </Typography>
          <Typography
            color="textSecondary"
            fontWeight={500}
            m={0}
          >
            Type
          </Typography>
        </ListHeader>
        <List>
          {filteredDevices.map(device => (
            <DeviceListItem
              key={device.id}
              onClick={() => handleDeviceClick(device.id)}
            >
              <DeviceIcon>
                <SettingsRemoteOutlinedIcon />
              </DeviceIcon>
              <ListItemText primary={device.uid} />
              <Typography variant="body2">{device.type}</Typography>
            </DeviceListItem>

          ))}
        </List>
      </ModalBox>
    </Modal>
  );
};

export default DevicesModal;
